<template>
    <v-dialog v-model="shows" persistent max-width="900">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card height="100%">
            <v-card-title>
                작품 카테고리 설정
                <v-spacer />
                <v-icon @click="shows = false">mdi-close</v-icon>
            </v-card-title>
            <v-divider />
            <v-card-text class="px-6 py-5" style="max-height: calc(90vh - 59px); overflow-y: auto">
                <v-row class="ma-n2">
                    <v-col cols="12" md="6" class="pa-2">
                        <v-card outlined flat v-bind="{ loading }">
                            <v-toolbar color="info lighten-1" dense flat>
                                <v-toolbar-title class="white--text subtitle-2"> 카테고리 순서변경 </v-toolbar-title>
                                <v-spacer />
                                <v-btn color="accent" fab dark small absolute bottom right @click="form = undefined">
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </v-toolbar>

                            <v-card-text>
                                <template v-if="categories.length">
                                    <v-draggable-treeview v-model="categories" item-key="_id" children="children" group="categories" dense @click="select" @input="update" />
                                </template>
                                <template v-else>
                                    <span>
                                        등록된 카테고리가 없습니다. <br />
                                        카테고리를 등록해주세요.
                                    </span>
                                </template>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="6" class="pa-2">
                        <auction-category-form :value="form" v-bind="{ categories, loading }" v-on="{ search, loading: (bool) => (loading = bool) }" />
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
import { initAuctionCategory } from "@/assets/inits";
import { AUCTION_CATEGORY_GROUPS } from "@/assets/variables";

import AuctionCategoryForm from "./auction-category-form.vue";

export default {
    components: {
        AuctionCategoryForm,
    },
    props: {
        group: { type: String, default: AUCTION_CATEGORY_GROUPS.PRIVATE.value },
    },
    data: () => ({
        form: initAuctionCategory(),
        categories: [],

        shows: false,
        loading: false,
    }),
    mounted() {
        this.init();
    },
    watch: {
        group() {
            this.init();
        },
    },
    methods: {
        async init() {
            const { group } = this;
            this.form = initAuctionCategory({ group });
            await this.search();
        },

        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                const { group } = this;
                let { categories } = await api.console.auction.categories.gets({
                    params: { depth: 1, group },
                });
                this.categories = categories;
                this.category = initAuctionCategory(categories[this.categories.findIndex(({ _id }) => _id == this.category?._id)]);
            } finally {
                this.loading = false;
            }
        },

        async select(category) {
            const { group } = this;
            if (this.form?._id == category?._id) this.form = initAuctionCategory({ group });
            else this.form = initAuctionCategory(category);
        },

        async update() {
            if (this.loading) return;
            else this.loading = true;

            try {
                await this.updateCategoryOrders(this.categories);
            } finally {
                this.loading = false;
            }
        },

        async updateCategoryOrders(categories, _parent, depth = 1) {
            for (var category of categories) {
                category.index = categories.indexOf(category);
                category.depth = depth;
                category._parent = _parent;

                if (category.children) {
                    await this.updateCategoryOrders(category.children, category._id, depth + 1);
                }
                await api.console.auction.categories.put(category);
            }
        },
    },
};
</script>
